import datepicker from 'js-datepicker'

const calendar = () => {

    const customDays = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
    const customMonths = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

    const calendars = document.querySelectorAll('.calendar');
    if (calendars && calendars.length > 0) {
        calendars.forEach(function (calendar) {
            const picker = datepicker(calendar.querySelector('input'), {
                startDay: 1,
                dateSelected: new Date(),
                customDays: customDays,
                customMonths: customMonths,
                formatter: (input, date, instance) => {
                    // This will display the date as `1/1/2019`.
                    let d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                    let m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
                    input.value = d + '.' + m + '.' + date.getFullYear();
                },
            })
        })
    }

    const calendarsNull = document.querySelectorAll('.calendar-null');
    if (calendarsNull && calendarsNull.length > 0) {
        calendarsNull.forEach(function (calendar) {
            let picker = datepicker(calendar.querySelector('input'), {
                position: 'br',
                startDay: 1,
                dateSelected: null,
                customDays: customDays,
                customMonths: customMonths,
                formatter: (input, date, instance) => {
                    let d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                    let m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
                    input.value = d + '.' + m + '.' + date.getFullYear();
                },
            })
        })
    }

    const calendarsNullTop = document.querySelectorAll('.calendar-null-top');
    if (calendarsNullTop && calendarsNullTop.length > 0) {
        calendarsNullTop.forEach(function (calendar) {
            let picker = datepicker(calendar.querySelector('input'), {
                position: 'tr',
                startDay: 1,
                dateSelected: null,
                customDays: customDays,
                customMonths: customMonths,
                formatter: (input, date, instance) => {
                    let d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                    let m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
                    input.value = d + '.' + m + '.' + date.getFullYear();
                },
            })
        })
    }

    const calendarFromAutoTo = document.querySelectorAll('.calendar-from-auto-to');
    if (calendarFromAutoTo && calendarsNull.length > 0) {
        calendarFromAutoTo.forEach(function (calendar) {
            let calenderTo = calendar.dataset.to;
            let inputCalendarTo = document.querySelector('input[name=' + calenderTo + ']');
            const picker = datepicker(calendar.querySelector('input'), {
                position: 'br',
                startDay: 1,
                dateSelected: null,
                customDays: customDays,
                customMonths: customMonths,
                formatter: (input, date, instance) => {
                    // This will display the date as `1/1/2019`.
                    let d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                    let m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
                    input.value = d + '.' + m + '.' + date.getFullYear();

                    let dateTo = date;
                    dateTo.setMonth(date.getMonth() + 12);

                    let dTo = dateTo.getDate() < 10 ? '0' + dateTo.getDate() : dateTo.getDate();
                    let mTo = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;

                    inputCalendarTo.value = dTo + '.' + mTo + '.' + dateTo.getFullYear();
                },
            })
        })
    }

}

export {calendar}
